var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasWrapper",staticClass:"pixi-renderer",style:({
        width: _vm.PIXIWrapper.sizes.canvasWidth + 'px',
        height: _vm.PIXIWrapper.sizes.canvasHeight + 'px'
    })},[_c('canvas',{ref:"canvas"}),_vm._v(" "),(_vm.ready)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }